import { gql } from '@apollo/client';

const USER_PROFILE_DETAILS_FRAGMENT = gql`
  fragment BaseUserProfileDetails on User {
    id
    username
    firstName
    lastName
    pin
  }
`;

export default USER_PROFILE_DETAILS_FRAGMENT;
